import React, { useEffect, useMemo, useState } from 'react';
import SignupContentWrapper from '../components/SignupContentWrapper';
import { useTranslation } from 'react-i18next';
import { PATH } from '../../../routes';
import { pushEvent } from '../../../utils/clevertapUtils';
import {
    CLICK_USER_PHONE_PAGE_OK_BTN,
    VIEW_USER_PHONE_PAGE,
} from '../../../utils/clevertapEvents';
import { useRouteConfig } from '../utils/useRouteConfig';
import SignupTextField from '../components/SignupTextField';
import { useSelector } from 'react-redux';
import { useAppDispatch } from 'store/hooks';
import { AppState } from '../../../store';
import { useNavigate } from 'react-router-dom';
import { signSetAction } from '../../../store/signup/actions';
import { phoneFormatter, phoneValidation } from '@givelify/givelify-ui';

const STEP_INFO = 2;

const UserPhoneNumber: React.FC = () => {
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const push = useNavigate();
    const defaultValue = useSelector(
        (state: AppState) => state.Signup.userPhone,
    );
    const [phone, setPhone] = useState<string>(defaultValue);
    const { next, previous } = useRouteConfig(PATH.SIGNUP.STEPS.SIX);

    const onSubmitFunc = () => {
        if (!phoneValidation(phone)) return;
        pushEvent(CLICK_USER_PHONE_PAGE_OK_BTN);
        dispatch(
            signSetAction({
                userPhone: phone,
            }),
        );
        next && push(next);
    };

    const copy = useMemo(
        () => ({
            heading: t('signup.userPhoneNumber.heading'),
            subHeading: t('signup.userPhoneNumber.subHeading'),
            validationErrorText: t(
                'signup.userPhoneNumber.errors.validationErrorText',
            ),
            nullErrorText: t('signup.userPhoneNumber.errors.nullErrorText'),
            placeholderText: t('signup.userPhoneNumber.placeholderText'),
        }),
        [t],
    );

    useEffect(() => {
        pushEvent(VIEW_USER_PHONE_PAGE);
    }, []);

    const handlePhoneNumber = (value: string) => {
        const phone = phoneFormatter(value);
        setPhone(phone || '');
    };

    return (
        <SignupContentWrapper
            heading={copy.heading}
            subHeading={copy.subHeading}
            stepInfo={STEP_INFO}
            showCloseButton={true}
            backUrl={previous}
        >
            <SignupTextField
                value={phone}
                isFocus={true}
                type="tel"
                errorText={copy.validationErrorText}
                nullErrorText={copy.nullErrorText}
                placeholder={copy.placeholderText}
                onChange={handlePhoneNumber}
                onSubmit={onSubmitFunc}
                validation={phoneValidation}
                maxLength={14}
            />
        </SignupContentWrapper>
    );
};

export default UserPhoneNumber;
